<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div class="main" v-html="content"></div>
  </div>
</template>

<script>
import { getNoticeInfo } from '@/api/music.js'
import { mapMutations } from 'vuex'
export default {
  name: 'FeatureDetail',
  data() {
    return {
      content: ''
    }
  },
  async created() {
    this.TOGGLE_LOADING(true)
    try {
      await this.getNoticeInfo()
    } finally {
      this.TOGGLE_LOADING(false)
    }

  },
  methods: {
    async getNoticeInfo() {
      const res = await getNoticeInfo({ id: this.$route.query.id, catid: this.$route.query.catid })
      this.content = res.data.content
    },
    ...mapMutations(['TOGGLE_LOADING'])
  }
}
</script>

<style lang="scss" scoped>
.main{
  padding: 0 16px
}
</style>
